import styled from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';
import Error from '../../assets/icons/Error.svg';
import SecondaryButton from '../ReactComponent/SecondaryButton';
import PrimaryButton from '../ReactComponent/PrimaryButton';
import Column from '../ReactComponent/Column';
import { H2 } from '../../theme/typography';

export const LoginPageContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  background-color: ${colors.LIGHT_GREY};

  ${MediaQuery.small`
    flex-direction: row;

    // Ensure content container edges line up with nav container edges...
    margin: 0 auto;
    padding: 40px 0px;
  `}
`;

const CustomColumn = styled(Column)`
  ${MediaQuery.small`
    flex-basis: 0 !important;
    flex-grow: 1 !important;
  `}
`;

export const ContentContainer = styled(CustomColumn)`
  display: grid;
  grid-gap: 40px;
  background-color: ${colors.WHITE};
  padding: 40px 20px !important;

  ${MediaQuery.small`
    padding: 64px !important;
    max-width: 478px !important;
  `}
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  & > div:first-child {
    margin-bottom: 24px;
  }
`;

export const StyledH2 = styled(H2)`
  font-size: 26px;
  line-height: 32px;

  ${MediaQuery.small`
    font-size: 28px;
    line-height: 36px;
  `}
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    margin-bottom: 0px;
  }
`;

export const HeaderSignUpContainer = styled.div`
  display: flex;
  text-transform: lowercase;

  div:first-child {
    margin-right: 3px;
  }
`;

export const SignUp = styled.div`
  text-decoration: underline;
  text-underline-position: under;
  cursor: pointer;
`;

export const LoginErrorContainer = styled.div`
  background-color: ${colors.ERROR5};
  border-radius: 1px;
  margin-bottom: 40px;
  padding: 12px;
`;

export const LoginErrorLabel = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.01em;

  div {
    align-self: center;
  }
`;

export const ErrorIcon = styled.img.attrs(() => ({ src: Error }))`
  margin-right: 8px;
`;

export const FieldContainer = styled(Column)`
  flex-basis: unset !important;

  ${MediaQuery.small`
    flex-basis: 0 !important;
  `}
`;

export const ForgotPasswordContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;
`;

export const ForgotPasswordSubContainer = styled.div`
  cursor: pointer;

  u {
    text-underline-position: under;
  }

  u:hover {
    text-decoration: underline;
    text-decoration-color: ${colors.BRAND_ORANGE};
    text-decoration-thickness: 2px;
    text-underline-position: under;
    font-weight: bold;
  }

`;

export const FormButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  ${MediaQuery.small`
    flex-direction: row;
  `}
`;

export const LoginButton = styled(PrimaryButton)`
  width: 100%;

  .children {
    flex: unset;
  }
`;

export const LinkButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const LinkButton = styled(SecondaryButton)`
  border: none;
  padding-left: 0;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  div:first-child {
    font-weight: 500;
    line-height: 18px;
    margin-bottom: 12px;
  }
`;

export const EmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  div:first-child {
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0.01em;
    margin-bottom: 4px;
  }

  u {
    font-weight: 500;
    line-height: 18px;
    text-underline-position: under;
  }

  u:hover {
    text-decoration: underline;
    text-decoration-color: ${colors.BRAND_ORANGE};
    text-decoration-thickness: 2px;
    text-underline-position: under;
    font-weight: bold;
  }
`;
